
require('angular-ui-bootstrap');

var vskoPanel = angular.module('vskoPanel', ['ui.bootstrap']);

// Panel
vskoPanel.directive('vskoPanel', [function() {
  return {
  restrict: 'E',
  template: function(element, attrs) { return require(angular.isDefined(attrs.collapse) ? './vsko-panel-collapsable.html':'./vsko-panel.html')},
  replace: false,
  transclude: true,
  scope: {
    isOpen: '=?',
    disabled:'=?'
  },
  controller: ['$scope', '$attrs', function($scope, $attrs) {
    'use strict';

    this.scope = $scope;
    $scope.isCollapsable = angular.isDefined($attrs.collapse);
    this.addHeadingToolbar= function(toolbar){
      $scope.hasToolbar = true;
    }

    if($scope.isCollapsable) {
        var id = 'collapsable-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);
        $scope.isOpen = $scope.isOpen || false;
        $scope.headingId = id + '-tab';
        $scope.panelId = id + '-panel';
    }
  }],
  controllerAs: 'vskoPanelCtrl',
  link: function(scope, element, attrs, vskoPanelCtrl, transclude) {

      'use strict';
      var panels = element.parents('.panel');
      if (panels.length > 0) {
        angular.element(panels[0]).addClass('panel-multi-level');
      }

       // Collapse option. Set the header and bodies
       if(scope.isCollapsable){
          transclude(function(clone) {
              angular.forEach(clone, function(cloneEl) {
                var cloneElEx = angular.element(cloneEl);
                if(cloneElEx.hasClass('panel-body')) {
                    element.find('.panel-collapse').append(cloneEl);
                }
                if(cloneElEx.hasClass('panel-heading')) {
                    element.find('.panel-collapse').before(cloneEl);
                }
            });
          });
       }
    }
}}])

// Heading
.directive('vskoPanelHeading', function() {
  return {
    require: '^vskoPanel',
    template: require('./vsko-panel-heading.html'),
    restrict: 'E',
    replace: true,
    controller: ['$scope', '$attrs', '$element', function($scope, $attrs, $element) {
        this.collapsableButton = 'collapsableButton.html';
        var panelCtrl = $element.controller('vskoPanel');
        this.panelScope = panelCtrl.scope;
        $scope.isCollapsable = this.panelScope.isCollapsable;
        this.addToolbar= function(toolbar){
          $scope.simplePanel = toolbar.internalToolbar;
          panelCtrl.addHeadingToolbar(toolbar);
        }
    }],
    controllerAs: 'vskoPanelHeadingCtrl',
    transclude: true,
    scope: {},
    link: function(scope, element, attrs, panelCtrl) {
       var panelScope = panelCtrl.scope;
       if(panelScope.isCollapsable){
         if(!angular.isDefined(scope.simplePanel)){
           scope.simplePanel = true;
         }
         element.attr('role', 'tab');
         element.attr('aria-selected', panelScope.isOpen);
         scope.$watch(function(){
           return panelScope.isOpen}, function(val) {
            element.attr('aria-selected', val);
         });         
       }
    }
  };
})

// Heading title
.directive('vskoPanelHeadingTitle', function() {
    return {
      require: '^vskoPanelHeading',
      template: require('./vsko-panel-heading-title.html'),
      restrict: 'E',
      replace: true,
      transclude: true,
      scope: {}, 
      link: function(scope, element, attrs, ctrl) {
        element.addClass(ctrl.panelScope.isCollapsable ? 'bc-toolbar-title' : 'panel-title');
      }
    };
  })

// Body
.directive('vskoPanelBody', function() {
  return {
    require: '^^vskoPanel',
    template: require('./vsko-panel-body.html'),
    restrict: 'E',
    replace: true,
    transclude: true,
    scope: { }
  };
})

// group
.directive('vskoPanelGroup', function() {
  return {
    restrict: 'E',
    scope:true,
    link: function(scope, element, attrs) {
      'use strict';
      element.addClass('panel-group');
      element.attr('role','tablist');
      element.attr('aria-multiselectable','true');
    }
  };
});
